import { generalHelpers } from '@tweddle-se-team/common/helpers'
import configHelpers from '@/store/helpers/configHelpers'
import localizationHelpers from '@/store/helpers/localizationHelpers'
import productHelpers from '@/store/helpers/productsHelpers'
import brandHelpers from './brandHelpers'
import loggedInUserHelpers from './loggedInUserHelpers'

const isServer = generalHelpers.isServer()

const sanitizeQueryParam = value => {
  if (value == null) {
    return ''
  }
  if (Array.isArray(value)) {
    return value[0] ?? ''
  }
  return value
}

export const getInitialStoreSetup = async ({ store, ctx = { req: null, query: { brand: '', language: '' } } }) => {
  const { req, query } = ctx
  const origin = isServer ? req?.headers?.host?.split(':')[0] : window.location.hostname

  const _brand = sanitizeQueryParam(query.brand ?? '')
  const language = sanitizeQueryParam(query.language ?? '')
  // This needs to be called before any other store helper
  // to ensure that the apiUrlClient is available in window.RUNTIME_CONFIG
  const apiUrlClient = await configHelpers.getApiURL(store)
  const [dictionary, products, configs, brand, user] = await Promise.all([
    localizationHelpers.getDictionary(store),
    productHelpers.getProducts(store, language),
    configHelpers.getConfigs({ store }),
    brandHelpers.initializeBrand(store)(origin, _brand),
    isServer && loggedInUserHelpers.getUserData(ctx, store),
    configHelpers.getCurrentVersion(store)
  ])
  return {
    apiUrlClient,
    dictionary,
    products,
    configs,
    brand,
    user
  }
}
